.container {
  display: flex;
  align-items: stretch;
  height: auto;
  max-height: unset;
  overflow-y: auto;
  flex-direction: column;
  @media only screen and (min-width: 1084px) {
    flex-direction: row;
    overflow: hidden;
    height: 100vh;
    max-height: 100vh;
  }
}

.main {
  background-color: var(--static-background-standard);
  width: 100%;
  height: 100%;
  padding: 4rem;

  display: flex;
  flex-direction: column;
  overflow: unset;
  @media only screen and (min-width: 1084px) {
    overflow-y: auto;
    overflow-x: hidden;
    width: 38.325rem;
    height: 100vh;
  }
}

.header {
  display: flex;
  flex-direction: column;
  gap: 38px;
}
.logo {
  color: var(--primary-enabled);
}
.aside {
  width: 100%;
  padding: 2rem 1rem;
  min-height: unset;
  background-image: linear-gradient(148deg, #cadfe3 0%, #cfdedb 100%);
  z-index: 0;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 1;
  @media only screen and (min-width: 1084px) {
    min-height: 100vh;
    padding: 2.5rem;
    }
}
/* .aside:after {
    background-image: url('/images/login-illustration.svg');
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    z-index: 1;
    content: "";
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
} */
